import React, { Component } from "react";
import Header from "../components/Header/Header";
import PersonalDetails from "../components/PersonalDetails/constarray.js";
import i18next from "i18next";

class ModifyUser extends Component {
  render() {
    const history = this.props.history;
    i18next.changeLanguage(localStorage.getItem("lang"));

    return (
      <>
        <Header />
        <PersonalDetails history={history} modifyUser={true} />
      </>
    );
  }
}

export default ModifyUser;
